import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-result-step',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule],
  templateUrl: './result-step.component.html',
  styleUrls: ['./result-step.component.scss']
})
export class ResultStepComponent {
  @Input() success: boolean = false;
  @Input() message: string = '';
  @Output() finish = new EventEmitter<number>();

  onFinish(value: number) {
    this.finish.emit(value);
  }
}
